import React from "react";
import { SearchableDropdown, TypeConstrainedCell } from "components";
import { DomainEnum } from "store/reducers/products/properties/pl-properties.types";
import { useDispatch } from "react-redux";
import {
  getSubPropertyValidation,
  editStandardSubPropertyPL,
} from "store/reducers/products/subproperties/pl-subproperties.actions";
import { useParentPropertyContext } from "../../pages/ProductDetail/ProductLineProperties/ParentPropertyContext";
import colors from "theme/colors";
import { ObjectAssignedEnum } from "types/validation";

export function StandardSubPropertiesInput({
  options,
  currentValue,
  propertyData,
  type,
}: {
  options?: any;
  currentValue: any;
  propertyData: any;
  type: "rulesets" | "default";
}) {
  const dispatch = useDispatch();
  const { parentId } = useParentPropertyContext();

  //Read the domain values of the subproperty and format them
  const values = propertyData.propertyValues
    .map((propertyValue) => {
      const value = propertyValue?.valueAttributeCells.find((cell) => {
        if (cell.propertyValueAttribute.name === "Value") return cell;
      });
      return value.value;
    })
    .filter((value) => value);

  const handleChange = (e) => {
    let newValue = e;

    if (
      (type === "default" && currentValue === e) ||
      (currentValue === "True" && e === true) ||
      (currentValue === "False" && e === false)
    ) {
      // when the value selected is the same
      // "deselect" the default value by setting it to empty string
      newValue = "";
    }

    dispatch(
      editStandardSubPropertyPL({
        propertyId: propertyData.id,
        changedProperty:
          type === "rulesets"
            ? { rulesetids: newValue }
            : { default: newValue },
        parentId,
      })
    );

    setTimeout(() => {
      dispatch(
        getSubPropertyValidation({
          parentId,
          objectId: propertyData.id,
          objectAssigned: ObjectAssignedEnum.PROPERTY,
          isStandardSubProperty: true,
        })
      );
    }, 2000);
  };

  const parseValue = () => {
    switch (propertyData.default) {
      case "true":
      case "True":
        return "true";

      case "false":
      case "False":
        return "false";

      case null:
        return "";

      default:
        return propertyData.default;
    }
  };

  if (type === "rulesets") {
    return (
      <SearchableDropdown
        multiselect
        searchable
        placeholder={"rulesets"}
        options={options || []}
        value={currentValue}
        handleValueChange={handleChange}
        name="standardSubpropRuleset"
        noShadow
        noHoverBorder
        backgroundColor={colors.tables.hoveredCell}
      />
    );
  }

  if (type === "default" && propertyData.domain === DomainEnum.DISCRETE) {
    return (
      <SearchableDropdown
        multiselect={false}
        searchable
        clearable
        options={values}
        value={values.includes(currentValue) ? currentValue : null}
        // Currently value is displayed as blank if currentValue is not in values.
        // This happens when value PVA selected is changed. In reality, the default
        // value points to the value PVA with its value updated. This is not new
        // behavior.
        handleValueChange={handleChange}
        name="default"
        noShadow
        noHoverBorder
        backgroundColor={colors.tables.hoveredCell}
      />
    );
  }

  return (
    <TypeConstrainedCell
      dataType={propertyData["dataType"]}
      type="editCell"
      handleSubmit={handleChange}
      value={parseValue()}
    />
  );
}
